import { type PositionChatResponse } from "../api";
import { Utility } from "./utility";

export interface PositionChat extends PositionChatResponse {}

export class PositionChat extends Utility<PositionChat> {
  constructor(init?: Partial<PositionChatResponse>) {
    super();
    Object.assign(this, init);
  }
}
